// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"418":"79dae905b83480ffec44","760":"f967f3b4252e65234250"}[chunkId] + ".chunk.js";
};